import ISocialLink from './ISocialLink'

import {
  EmailShareButton,
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton
} from 'react-share'

import { homeUrl } from 'config'

const url = homeUrl || ''

const links: ISocialLink[] = [
  {
    Wrapper: WhatsappShareButton,
    url,
    socialType: 'whatsapp',
    type: 'wa',
    otherProps: {
      title:
        'Have you tried mapping your child’s unique abilities with GiantLeap?'
    }
  },
  {
    Wrapper: FacebookShareButton,
    url,
    socialType: 'facebook',
    type: 'fb',
    otherProps: {
      hashtag: '#giantleap'
    }
  },
  {
    Wrapper: TwitterShareButton,
    url,
    socialType: 'twitter',
    type: 'tw',
    otherProps: {
      title:
        'Child development made easy. Have you tried mapping your child’s unique abilities with GiantLeap?',
      hashtags: ['giantleap']
    }
  },
  {
    Wrapper: EmailShareButton,
    url,
    socialType: 'gmail',
    type: 'gm',
    otherProps: {
      subject: 'GiantLeap | Child development made easy',
      body: `Have you tried mapping your child’s unique abilities with GiantLeap?`,
      separator: '\n'
    }
  }
]

export default links



// WEBPACK FOOTER //
// ./src/components/ShareModal/links.ts